module.exports = __webpack_public_path__ + "static/img/setting-1x.47c38ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/setting-1x.png
// module id = Hsb+
// module chunks = 53